import debounce from 'lodash.debounce';
import { useCallback, useState } from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
import { useVariable } from './useVariable';
export const useDebounce = (value, delay = 100) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const updateDebouncedValue = useVariable(useCallback(debounce(newValue => {
    setDebouncedValue(newValue);
  }, delay), [delay]));
  useDidUpdateEffect(() => {
    updateDebouncedValue.current?.(value);
  }, [value]);
  return debouncedValue;
};